<template>
  <validation-provider :name="texto" :rules="{ required: requerida }" v-slot="validationContext">
    <b-form-group label-cols-md="4" :label="texto + ':'" :label-for="realId">
      <b-form-input type="text" maxlength="128" :id="realId" v-model="respuesta" :placeholder="placeholder" :state="getValidationState(validationContext)" autocomplete="off"></b-form-input>
      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      <b-form-text v-if="ayuda">{{ ayuda }}</b-form-text>
    </b-form-group>
  </validation-provider>
</template>

<script lang="ts">
import { nanoid } from 'nanoid'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import settings from '../../settings'

@Component
export default class TipoTexto extends Vue {
  @Prop() id: string
  @Prop() texto: string
  @Prop({default: ''}) ayuda: string
  @Prop({default: true}) requerida: Boolean
  @Prop() placeholder: string
  @Prop() value: any

  get realId(): string {
    return this.id || 'texto-' + nanoid()
  }

  public respuesta: any = null

  getValidationState({validated, dirty = null, valid = null, passed = null}) {
    return validated || valid ? valid : null
  }

  @Watch('respuesta')
  onRespuestaChange(value) {
    this.$emit('input', value)
    this.$emit('respuesta.' + this.id, value)
  }

  @Watch('value')
  onValueChange(value) {
    this.respuesta = value
  }

  created() {
    this.respuesta = this.value || null
  }
}
</script>